import './day-of-month';
import './day-of-week';
import './day-of-year';
import './month';
import './week';
import './week-calendar-utils';
import './year';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/units/index.js
// module id = 853
// module chunks = 103